import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import useEnvironment from "@shared/hooks/useEnvironment";
const mapStyled = {
    backgroundColor: "background.paper",
    padding: 1,
    "& .leaflet-container": {
        width: "100%",
        height: 364,
        zIndex: 1,
    },
    "& .leaflet-left": {
        right: 10,
        left: "auto",
    },
};
const GeographicMap = (props) => {
    const { id = "", name = "", latitude = "", longitude = "", initialZoom = "10", address = "", city = "", postalCode = "", ...others } = props;
    const [mapComponents, setMapComponents] = useState({});
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
    const { geoloc_url, geoloc_licence } = useEnvironment();
    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        const loadMap = async () => {
            const L = await import("leaflet");
            const defaultIcon = L.icon({
                iconUrl: icon,
                shadowUrl: iconShadow,
                iconSize: [24, 36],
                iconAnchor: [12, 36],
                popupAnchor: [0, -40],
            });
            L.Marker.prototype.options.icon = defaultIcon;
            await import("leaflet/dist/leaflet.css");
            const reactLeaflet = await import("react-leaflet");
            setMapComponents(reactLeaflet);
        };
        loadMap();
    }, []);
    const mapRef = useRef(null);
    const { MapContainer, Marker, Popup, TileLayer } = mapComponents;
    const invalidateMap = () => {
        setTimeout(() => {
            if (mapRef.current) {
                mapRef.current.invalidateSize(false);
            }
        }, 0);
    };
    const location = {
        position: [Number(latitude), Number(longitude)],
        longitude,
        name,
        address,
        city,
        postalCode,
    };
    if (!MapContainer || !Marker || !Popup || !TileLayer) {
        return null;
    }
    return (_jsx(Box, { sx: mapStyled, children: _jsxs(MapContainer, { center: location.position, zoom: Number(initialZoom), ref: mapRef, zoomControl: !isMobile, whenReady: invalidateMap, ...others, children: [geoloc_url && (_jsx(TileLayer, { url: `${geoloc_url}/{z}/{x}/{y}.png`, attribution: geoloc_licence, referrerPolicy: "strict-origin-when-cross-origin" })), _jsx(Marker, { position: location.position, children: _jsx(Popup, { children: _jsxs(Box, { sx: {
                                "& p": {
                                    bgcolor: "white",
                                    m: "0 !important",
                                },
                            }, children: [_jsx(Typography, { color: "primary", children: location.name }), _jsx(Typography, { color: "primary", children: location.address }), _jsxs(Typography, { color: "primary", children: [location.postalCode, " ", location.city] })] }) }) })] }, id) }));
};
export default GeographicMap;
